/**
 * OAuth2 callback page.
 *
 * Handles the redirect from Cognito after authentication.
 * Waits for the AuthProvider to exchange the authorization code for tokens,
 * then redirects to the app.
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth';
import { Spinner } from '../../components/ui';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    // Wait for auth to finish loading, then redirect based on auth state
    if (!isLoading) {
      if (isAuthenticated) {
        // Successfully authenticated - go to main app
        navigate('/', { replace: true });
      } else {
        // Auth failed - the URL code was already consumed but token exchange failed
        // Navigate anyway and let RequireAuth handle the login redirect
        navigate('/', { replace: true });
      }
    }
  }, [isLoading, isAuthenticated, navigate]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: '1rem',
      }}
    >
      <Spinner size="lg" />
      <p>Completing sign in...</p>
    </div>
  );
}
